module.exports = __webpack_public_path__ + "media/custom/images/img21-a57cfd3246468a16bab8189809583b99.png";